/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';
import { computed } from '@ember/object';
import SetupGuideChannelsMessagingSetup from 'cio/components/setup-guide/channels/messaging/setup';
import { MessagingChannelType } from 'cio/utils/setup-guide/messaging-channels';
import AlertsService from 'cio/services/alerts';
import AuthService from 'cio/services/auth';

export default class SetupGuideChannelsMessagingTwilio extends SetupGuideChannelsMessagingSetup {
  @service auth!: AuthService;
  @service environment!: EnvironmentService;
  @service alerts!: AlertsService;

  channel = MessagingChannelType.Twilio;
  showSuccessAlert = false; // twilio config handles this internally

  @computed('environment.current.identities.@each.{autoGenerated,templateType}')
  get twilioPhoneNumbers() {
    return this.environment.current.identities
      .filter((identity) => identity.templateType === 'twilio')
      .filter((identity) => identity.autoGenerated);
  }

  @computed('twilioPhoneNumbers.@each.name')
  get twilioPhoneNumberIdentifiers() {
    return this.twilioPhoneNumbers.slice(0, 3).map((identity) => identity.name);
  }

  get hasCreateTwillioPermission() {
    // eslint-disable-next-line spellcheck/spell-checker
    return this.auth.hasPermission('journeys/twillio_message_settings/create');
  }
}
